import { client } from './client';

export const gpsApi = {
  updateLocation: (params) => client.post('update_gps_location', params),
  getEmployeeLastLocation: (employee_id) => client.get('get_employee_last_gps_location', { params: { employee_id } }),
  getKnownPlaces: () => client.get('get_gps_known_places'),
  addKnownPlace: (params) => client.post('add_gps_known_place', params),
  updateKnownPlace: (params) => client.post('update_gps_known_place', params),
  deleteKnownPlace: (id) => client.post('delete_gps_known_place', { id }),
  getDailyReportEmployees: (date) => client.get('get_gps_daily_report_employees', { params: { date } }),
  getDailyReport: (employee_id, date) => client.get('get_gps_daily_report', { params: { employee_id, date } }),
};
